module.exports = __webpack_public_path__ + "ae435d6ce6740c76adba11d303748ce6.svg";